<template>
  <!-- 查看流程图 -->
  <JFDrawer destroy-on-close title="查看流程图" v-model="visible">
    <a :href="flowPicUrl" title="点击查看大图" target="_blank">
      <img class="img-fluid" :src="flowPicUrl">
    </a>
    <template slot="footer">
      <Button type="primary"
              :long="isMobile"
              @click="visible = false">关闭</Button>
    </template>
  </JFDrawer>
</template>
<script>
  import { mapState } from 'vuex'
  import { getOssSignedUrl, isOssUrl } from '@/plugins/utils'

  export default {
    name: 'FlowPic',
    computed: {
      ...mapState('admin/layout', ['isMobile']),
    },
    methods: {
      async init (flowPicUrl) {
        this.visible = true
        // 当前 OSS 私有 bucket 的 URL 需生成授权（签名）URL；非 OSS URL 保持原始地址直接查看/下载
        const displayUrl = await getOssSignedUrl(flowPicUrl)
        this.flowPicUrl = displayUrl
      }
    },
    data () {
      return {
        visible: false,
        flowPicUrl: ''
      }
    },
  }
</script>

<style scoped lang="less">
  .img-fluid {
    display: block;
    max-width: 100%;
    height: auto;
  }
</style>
